import React, { Component } from 'react';
import ReactDOM from "react-dom";
import {observer} from "mobx-react";

@observer
class Modal extends Component {
    render() {
        return ReactDOM.createPortal(
            <div className="modal-cover">
                <div className={"modal " + this.props.class}>
                    {this.props.children}
                </div>
            </div>,
            document.body,
        );
    }
}

export default Modal;
